import { render, staticRenderFns } from "./doctorsSharing.vue?vue&type=template&id=7c82a17e&scoped=true&"
import script from "./doctorsSharing.vue?vue&type=script&lang=js&"
export * from "./doctorsSharing.vue?vue&type=script&lang=js&"
import style0 from "./doctorsSharing.vue?vue&type=style&index=0&id=7c82a17e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c82a17e",
  null
  
)

export default component.exports